import { useSearchParams } from "react-router-dom";
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import OwnerFinanceHistoricalView from "./stats/OwnerFinanceHistoricalView";
import OwnerFinanceFutureView from "./stats/OwnerFinanceFutureView";

export default function OwnerStatisticsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("vista") === "futuro" ? "future" : "history";
  const setView = (next) => {
    const params = new URLSearchParams(searchParams);
    if (next === "future") params.set("vista", "futuro");
    else params.set("vista", "historico");
    setSearchParams(params, { replace: true });
  };

  return (
    <Box sx={{ pb: 1, maxWidth: 1740, mx: "auto" }}>

      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.2} sx={{ mb: .7 }}>
        <ToggleButtonGroup exclusive size="small" value={view} onChange={(_, next) => next && setView(next)} sx={{ width: { xs: "100%", sm: "auto" }, "& .MuiToggleButton-root": { flex: { xs: 1, sm: "0 0 auto" }, px: { xs: 1, sm: 1.7 }, minWidth: 0, textTransform: "none", fontWeight: 900 } }}>
          <ToggleButton value="history">Histórico</ToggleButton>
          <ToggleButton value="future">Futuro / Metas</ToggleButton>
        </ToggleButtonGroup>
        <Typography sx={{ display: { xs: "none", md: "block" }, color: "text.secondary", fontSize: 12.5, fontWeight: 700 }}>
          Histórico = hechos · Futuro = hipótesis y objetivos
        </Typography>
      </Stack>

      {view === "history" ? <OwnerFinanceHistoricalView /> : <OwnerFinanceFutureView />}
    </Box>
  );
}
